export default __webpack_public_path__ + "static/media/banner-img2.b819b425.jpg";